// Detecte le type de flux d'une chaine et renvoie comment le lire.
// kind: 'hls' | 'native' | 'iframe' | 'none'

export function parseYouTube(url) {
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|live\/|embed\/|v\/)|youtu\.be\/)([\w-]{11})/);
  if (m) return m[1];
  return null;
}

export function resolveStream(rawUrl) {
  if (!rawUrl || typeof rawUrl !== "string") return { kind: "none", src: "" };
  const url = rawUrl.trim();
  const lower = url.toLowerCase();

  // YouTube (watch / live / youtu.be / embed) -> embed iframe
  const yt = parseYouTube(url);
  if (yt) {
    return { kind: "iframe", src: `https://www.youtube.com/embed/${yt}?autoplay=1&mute=1&playsinline=1` };
  }

  // Pages d'integration / lecteurs embarques connus -> iframe
  const IFRAME_HINTS = [
    "iframe.dacast.com", "player.dacast", "/embed", "player.twitch.tv", "dailymotion.com/embed",
    "facebook.com/plugins/video", "vimeo.com", "player.vimeo.com", "/iframe/", "/iframe?", "wowza",
    "flowplayer", "brightcove", "streamable.com", "kick.com",
  ];
  if (IFRAME_HINTS.some((h) => lower.includes(h))) {
    return { kind: "iframe", src: url };
  }

  // Manifest HLS
  if (lower.includes(".m3u8")) return { kind: "hls", src: url };

  // Fichiers video lisibles nativement
  if (/\.(mp4|webm|ogg|mov|m4v)(\?|$)/.test(lower)) return { kind: "native", src: url };

  // MPEG-DASH
  if (lower.includes(".mpd")) return { kind: "iframe", src: url };

  // Par defaut : une URL non reconnue est le plus souvent une page d'integration
  return { kind: "iframe", src: url };
}
